import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, Slider, InputNumber, Table, Tooltip } from 'antd'
import { Link } from 'dva/router'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get, update, remove } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

class Subsidy extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            Subsidy: [],
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.incomeType === 'cash_funds_trie' || this.props.incomeType === 'others_trie' || this.props.incomeType === 'payroll_trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        this.firstLoad();
    }


    /**
    * Consulta los registros
    */
    firstLoad () {
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('Subsidy', {limit: 1000}).then((resp) => {

            this.props.dispatch({type: 'app/hideLoadingTable'})
            this.setState({ Subsidy: resp.results });
        });
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Envío del formulario
    */
    updateSubsidy (item) {

        // Model
        let data = {...item};

        if (this.props.form.getFieldValue(item.objectId + '_inferior_limit'))
            _.isNumber(this.props.form.getFieldValue(item.objectId + '_inferior_limit')) ? data.inferior_limit = this.props.form.getFieldValue(item.objectId + '_inferior_limit') : data.inferior_limit = Number(this.props.form.getFieldValue(item.objectId + '_inferior_limit').replace(/[^\d.-]/g, ''))
        else
            data.inferior_limit = 0;


        if (this.props.form.getFieldValue(item.objectId + '_superior_limit'))
            _.isNumber(this.props.form.getFieldValue(item.objectId + '_superior_limit')) ? data.superior_limit = this.props.form.getFieldValue(item.objectId + '_superior_limit') : data.superior_limit = Number(this.props.form.getFieldValue(item.objectId + '_superior_limit').replace(/[^\d.-]/g, ''))
        else
            data.superior_limit = 0;


        if (this.props.form.getFieldValue(item.objectId + '_quantity'))
            _.isNumber(this.props.form.getFieldValue(item.objectId + '_quantity')) ? data.quantity = this.props.form.getFieldValue(item.objectId + '_quantity') : data.quantity = Number(this.props.form.getFieldValue(item.objectId + '_quantity').replace(/[^\d.-]/g, ''))
        else
            data.quantity = 0;

        data = _.omit(data, ['createdAt', 'updatedAt']);

        this.props.dispatch({type: 'app/showButtonLoading'})
        this.props.dispatch({type: 'app/showLoadingTable'})

        update('Subsidy', data.objectId, data).then(resp => {

            this.props.dispatch({type: 'app/hideButtonLoading'})
            this.props.dispatch({type: 'app/hideLoadingTable'})

            message.success('Se ha actualizado el registro exitosamente');

        }).catch(e => {
            this.props.dispatch({type: 'app/hideButtonLoading'})
            this.props.dispatch({type: 'app/hideLoadingTable'})

            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error. Intente más tarde')    
        });
    }


    /**
    * Render del componente
    */
    render () {
        return (
            <Form>
                <div className="row">
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="col-md-12">
                            <Table 
                                dataSource={this.state.Subsidy} 
                                rowKey="objectId" 
                                size="middle" 
                                pagination={false} >

                                <Column title="Límite Inferior" key="inferior_limit" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_inferior_limit', {
                                            initialValue: item.inferior_limit,
                                            rules: [{}, {
                                                validator: this.checkAmount.bind(this)
                                            }]
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Límite Superior" key="superior_limit" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_superior_limit', {
                                            initialValue: item.superior_limit,
                                            rules: [{}, {
                                                validator: this.checkAmount.bind(this)
                                            }]
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Cantidad" key="quantity" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_quantity', {
                                            initialValue: item.quantity
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Acciones" key="action" width={90}
                                    render={(item) => (
                                        <span className="actions">
                                            <ButtonGroup>
                                                <Tooltip placement="bottom" title="Actualizar">
                                                    <Button>
                                                        <Link onClick={() => { this.updateSubsidy(item) }}><Icon name="save" /></Link>
                                                    </Button>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </span>
                                    )}
                                />
                            </Table>  
                        </div>
                    </Spin>
                </div>
            </Form>
        )
    }
}

Subsidy.contextTypes = {
    router: PropTypes.object.Subsidyequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(Subsidy))


// WEBPACK FOOTER //
// ./src/components/config/subsidy.js